import { useHistory } from 'react-router-dom';
import Headers from '~/view/containers/Headers/Headers';
import HeaderBack from '~/view/containers/Headers/components/HeaderBack/HeaderBack';
import PromocodeLogHeader from '~/view/screens/PromocodeLogScreen/components/PromocodeLogHeader';
import PromocodeLogList from '~/view/screens/PromocodeLogScreen/components/PromocodeLogList';

const PromocodeLogScreen = () => {
  const history = useHistory();

  return (
    <div className="d-flex flex-column full-width">
      <Headers>
        <HeaderBack title="promocodelog_promocode_usage_log_header" path="" callback={() => history.goBack()} />
      </Headers>
      <PromocodeLogHeader />
      <PromocodeLogList />
    </div>
  );
};

export default PromocodeLogScreen;
